import React from 'react';
import ChangeTable from './ChangeTable';

const DefenderDocs = () => {
  return (
    <ChangeTable
      title="Recent Microsoft Defender Documentation Changes"
      dataSource="defender-changes.json"
      showGuideLink={false}
    />
  );
};

export default DefenderDocs;
